import React, { useEffect, useState } from "react";
import CommonLayout from "../../../../Components/CommonLayout/CommonLayout";
import { TemplateApi } from "../../../../App/api/setting";
import { useFetchAll } from "../../../../custom/FetchApiHook";
import ReactQuill from "react-quill";
import { toast } from "react-toastify";
import DeliveryManPrivacy from "./Tab/DeliveryManPrivacy";
import StorePolicy from "./Tab/StorePolicy";
import CustomerTNC from "./Tab/CustomerTNC";
import DeliveryManTNC from "./Tab/DeliveryManTNC";
import StoreTNC from "./Tab/StoreTNC";

const toolbarOptions = [
  [{ font: [] }, { size: [] }],
  ["bold", "italic", "underline", "strike"],
  [{ script: "sub" }, { script: "super" }],
  ["blockquote", "code-block"],
  [{ header: 1 }, { header: 2 }],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ align: [] }],
  ["link"],
  ["clean"],
];

const PrivacyAndTerm = ({meta}) => {
  const [activeTab, setActiveTab] = useState(0);
  const { value: privacyData } = useFetchAll(() =>
    TemplateApi.privacyAndTerms.getCustomerPolicy()
  );

  const { _id } = privacyData?.data?.length > 0 ? privacyData?.data?.[0] : [];

  console.log("id", _id);
  const [editorContent, setEditorContent] = useState("");

  // Fetch data and update editor content
  useEffect(() => {
    if (privacyData?.data?.length) {
      const { customerPrivacyPolicy = "" } = privacyData.data[0];
      setEditorContent(customerPrivacyPolicy);
    }
  }, [privacyData]);

  const handlePrivacypolicy = async (value) => {
    const payload = { customerPrivacyPolicy: value };

    try {
      if (_id) {
        const res = await TemplateApi.privacyAndTerms.updateCustomerPolicy(
          payload,
          _id
        );
        toast.success("Privacy Policy updated successfully");
      } else {
        const res = await TemplateApi.privacyAndTerms.customerPolicy(payload);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const tabs = [
    "Customer Privacy Policy",
    "Customer Term & Condition",
    "Delivery Man Privacy Policy",
    "Delivery Term & Condition",
    "Store Privacy Policy",
    "Store Term & Condition",
  ];

  return (
    <div>
      <CommonLayout />
      <div className="w-full mb-28">
        {/* Tab headers */}
        <div className="relative mx-10 flex space-x-4 border-b-2  border-gray-300">
          {tabs.map((tab, index) => (
            <button
              key={index}
              onClick={() => setActiveTab(index)}
              className={`relative py-2 uppercase px-4 transition duration-300 ${
                activeTab === index
                  ? "text-[var(--color--2)] font-semibold"
                  : "text-gray-600"
              }`}
            >
              {tab}
              {activeTab === index && (
                <span className="absolute bottom-[-2px] left-0 w-full h-[3px] bg-[var(--color--2)] rounded-t-md" />
              )}
            </button>
          ))}
        </div>

        {/* Tab content */}
        <div className="mt-6 mx-8">
          {activeTab === 0 && (
            <div className="w-full rounded-md mx-auto p-5 bg-white">
              <div className="flex justify-between ">
                <h1 className="text-xl text-gray-600  font-bold">
                  Customer Privacy Policy
                </h1>
                <button
                  className="mb-5 text-white bg-[var(--color--2)] px-2 py-1 rounded-md"
                  onClick={() => handlePrivacypolicy(editorContent)}
                >
                  {_id ? "Update" : "Add"}
                </button>
              </div>
              <ReactQuill
                value={editorContent}
                onChange={setEditorContent} // Directly set editor content
                theme="snow"
                className="bg-white shadow-sm rounded-md "
                modules={{ toolbar: toolbarOptions }}
              />
            </div>
          )}
          {activeTab === 1 && <CustomerTNC />}
          {activeTab === 2 && <DeliveryManPrivacy />}
          {activeTab === 3 && <DeliveryManTNC />}
          {activeTab === 4 && <StorePolicy />}
          {activeTab === 5 && <StoreTNC />}
        </div>
      </div>
    </div>
  );
};

export default PrivacyAndTerm;
